import { Component, inject, OnInit } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { bind } from 'cuelume';
import { TokenStorageService } from './core/services/token-storage.service';
import { OverlayService } from './core/services/overlay.service';
import { NotificationService } from './core/services/notification.service';
import { ThemeService } from './core/services/theme.service';
import { AppUiStateService } from './core/services/app-ui-state.service';
import { BottomNavComponent } from './shared/components/bottom-nav/bottom-nav.component';
import { OfflineIndicatorComponent } from './shared/components/offline-indicator/offline-indicator.component';
import { SwUpdateNotificationComponent } from './shared/components/sw-update-notification/sw-update-notification.component';
import { SyncStatusComponent } from './shared/components/sync-status/sync-status.component';
import { PwaInstallBannerComponent } from './shared/components/pwa-install-banner/pwa-install-banner.component';
import { ToastContainerComponent } from './shared/components/toast-container/toast-container.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    BottomNavComponent,
    NgTemplateOutlet,
    OfflineIndicatorComponent,
    SwUpdateNotificationComponent,
    SyncStatusComponent,
    PwaInstallBannerComponent,
    ToastContainerComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  private readonly tokenStorage = inject(TokenStorageService);
  readonly overlayService = inject(OverlayService);
  private readonly notificationService = inject(NotificationService);
  private readonly themeService = inject(ThemeService);
  readonly appUiState = inject(AppUiStateService);

  ngOnInit(): void {
    this.notificationService.startListeningForPushMessages();
    this.themeService.init();
    // Initialize Cuelume sound bindings
    bind();
  }

  get isLoggedIn(): boolean {
    return this.tokenStorage.isLoggedIn();
  }
}